module.exports = __webpack_public_path__ + "img/horizontal_6_1_pp1_7005.05fcce4c.png";